import { getSafeTracer, SpanStatusCode } from '../tracing/setup';
const TRACER_NAME = 'quick-fetch';
const INSTRUMENTED_FLAG = '__otel_qf_instrumented';
export function instrumentQuickFetch() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const qf = window.quickFetch;
  if (!qf || qf[INSTRUMENTED_FLAG]) return;
  qf[INSTRUMENTED_FLAG] = true;
  const originalGetRequestState = qf.getRequestStateByName.bind(qf);
  qf.getRequestStateByName = name => {
    const earlyRequest = originalGetRequestState(name);
    if (!earlyRequest || typeof earlyRequest !== 'object') {
      return earlyRequest;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const req = earlyRequest;
    if (typeof req.whenFinished !== 'function') return earlyRequest;
    const tracer = getSafeTracer(TRACER_NAME);
    const startTime = performance.now();
    const alreadyComplete = req.finished === true || req.error === true;
    const span = tracer.startSpan(`quickfetch ${name}`, {
      attributes: {
        'quickfetch.request_name': name,
        'quickfetch.already_complete': alreadyComplete
      }
    });
    let spanEnded = false;
    req.whenFinished(() => {
      var _req$request;
      if (spanEnded) return;
      spanEnded = true;
      const waitMs = performance.now() - startTime;
      span.setAttributes({
        'quickfetch.wait_ms': Math.round(waitMs)
      });
      if ((_req$request = req.request) !== null && _req$request !== void 0 && _req$request.responseURL) {
        span.setAttribute('quickfetch.url', req.request.responseURL);
      }
      span.setStatus({
        code: SpanStatusCode.OK
      });
      span.end();
    });
    if (typeof req.onError === 'function') {
      req.onError((xhr, errorMsg) => {
        var _xhr$status;
        if (spanEnded) return;
        spanEnded = true;
        const waitMs = performance.now() - startTime;
        span.setAttributes({
          'quickfetch.wait_ms': Math.round(waitMs),
          'http.response.status_code': (_xhr$status = xhr === null || xhr === void 0 ? void 0 : xhr.status) !== null && _xhr$status !== void 0 ? _xhr$status : 0,
          'error.type': errorMsg
        });
        if (xhr !== null && xhr !== void 0 && xhr.responseURL) {
          span.setAttribute('quickfetch.url', xhr.responseURL);
        }
        span.setStatus({
          code: SpanStatusCode.ERROR
        });
        span.end();
      });
    }
    return earlyRequest;
  };
}